


import { GeneralSelectInputs } from "models/Client/GeneralSelectInputs";
import { FC,} from "react";
import { MazakaSelect } from "./MazakaSelect";
import useCapitalize from "./Adress/helpers/useCapitalize";
import { useGetStores, useGetStoresByUser } from "apps/CustomerPanel/Store/ServerSideStates";


const GeneralStoreByUser: FC<GeneralSelectInputs> = (props) => {

  const stores = useGetStoresByUser();
  let { capitalize } = useCapitalize();


  return (
    <>
      <MazakaSelect
        name={props.name}
        xs={props.xs}
        sm={props.sm}
        md={props.md}
        lg={props.lg}
        xl={props.xl}
        size={props.size}
        loading={stores.isLoading || stores.isFetching}
        disabled={stores.isLoading || stores.isFetching || props.disabled}
        className={props.className}
        showSearch={true}
        allowClear={props.allowClear || false}
        filterOption={(input, option: any) =>
          (option.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        label={props.label}
        options={
          stores.data?.data
            ? stores.data?.data.map((item: any) => {
                return {
                  key: item.id,
                  taxNumber:item.taxNumber,
                  value: item.id,
                  label: capitalize(item.storeName),
                };
              })
            : []
        }
        placeholder={props.placeholder}
        mode={props.mode}
        onChange={props?.form?(value:string,obj)=>{
      
          props.form.setFieldValue(props.name,obj)
        }:props.onChange}
        value={props.value}
        rules={props.rules}
      />
    </>
  );
};

export default GeneralStoreByUser;
